<template>
    <div class="main__section">
        <sidebar></sidebar>
        <div class="detailedstep">
            <div class="detailedstep__form">
                <p class="detailedstep__title">Business information</p>
                <div class="detailedstep__input">
                    <input type="text" name="business_name" placeholder="Business Name*" class="input__text " :class="{ 'input__text--error': $v.form.business.name.$error }" v-model="$v.form.business.name.$model" />
                    <span class="detailedstep__error" v-if="$v.form.business.name.$error && !$v.form.business.name.required">Business name is required</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>
                <div class="detailedstep__input">
                    <multiselect name="business_country" id="business_country" :allow-empty="false" @input="fetchCounties()" label="name" track-by="id" :options="getCountriesList" :searchable="true" :close-on-select="true" :multiple="false" placeholder="Search countries*" v-model="$v.form.business.country.$model" class="input__select " :class="{ 'input__text--error': $v.form.business.country.$error }">
                     </multiselect>
                    <span class="detailedstep__error" v-if="$v.form.business.country.$error && !$v.form.business.country.required">Country is required</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>

                <div class="detailedstep__input">
                    <multiselect name="business_county" @input="fetchCities()" :allow-empty="false" label="name" track-by="id" :options="counties_list" :searchable="true" :close-on-select="true" :multiple="false" placeholder="Search counties*" v-model="$v.form.business.county.$model" class="input__select " :class="{ 'input__text--error': $v.form.business.county.$error }">
                    </multiselect>
                    <span class="detailedstep__error" v-if="$v.form.business.county.$error && !$v.form.business.county.required">County is required</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>

                <div class="detailedstep__input">
                    <multiselect name="business_town" :allow-empty="false" label="name" track-by="id" :options="cities_list" :searchable="true" :close-on-select="true" :multiple="false" placeholder="Search towns*" v-model="$v.form.business.town.$model" class="input__select " :class="{ 'input__text--error': $v.form.business.town.$error }">
                    </multiselect>
                    <span class="detailedstep__error" v-if="$v.form.business.town.$error && !$v.form.business.town.required">Town is required</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>

                <div class="detailedstep__input">
                    <input type="text" name="business_address" placeholder="Address*" class="input__text" :class="{ 'input__text--error': $v.form.business.address.$error }" v-model="$v.form.business.address.$model" />
                    <span class="detailedstep__error" v-if="$v.form.business.address.$error && !$v.form.business.address.required">Address is required</span>
                    <span class="detailedstep__error" v-if="$v.form.business.address.$error && !$v.form.business.address.maxLength">Max length is 150 characters</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>
                <div class="detailedstep__input">
                    <input type="text" name="business_website" placeholder="Website" class="input__text"  v-model="form.business.website" />                     
                    <span class="detailedstep__valid">Field ok</span>
                </div>

                <div class="detailedstep__input">
                    <input type="email" name="business_email" placeholder="Business Email*" class="input__text" :class="{ 'input__text--error': $v.form.business.email.$error }" v-model="$v.form.business.email.$model"  />
                    <span class="detailedstep__error" v-if="$v.form.business.email.$error && !$v.form.business.email.required">Business email is required</span>
                    <span class="detailedstep__error" v-else-if="$v.form.business.email.$error && !$v.form.business.email.email">Please enter a valid email</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>
                <div class="detailedstep__input">
                    <input type="text" name="business_phone" placeholder="Telephone*" class="input__text" :class="{ 'input__text--error': $v.form.business.phone.$error }" v-model="$v.form.business.phone.$model" />
                    <span class="detailedstep__error" v-if="$v.form.business.phone.$error && !$v.form.business.phone.required">Business phone number is required</span>
                    <span class="detailedstep__error" v-else-if="$v.form.business.phone.$error && !$v.form.business.phone.phoneValid">Please enter a valid phone number</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>

                <p class="detailedstep__title">Contact person</p>
                <div class="detailedstep__input">
                    <input type="text" name="contact_name" placeholder="First Name*" class="input__text" :class="{ 'input__text--error': $v.form.contact.name.$error }" v-model="$v.form.contact.name.$model" />
                    <span class="detailedstep__error" v-if="$v.form.contact.name.$error && !$v.form.contact.name.required">First name is required</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>
                <div class="detailedstep__input">
                    <input type="text" name="contact_surname" placeholder="Surname*" class="input__text" :class="{ 'input__text--error': $v.form.contact.surname.$error }" v-model="$v.form.contact.surname.$model"  />
                    <span class="detailedstep__error" v-if="$v.form.contact.surname.$error && !$v.form.contact.surname.required">Contact surname is required</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>
                <div class="detailedstep__input">
                    <input type="email" name="contact_email" placeholder="Contact Person Email*" class="input__text" :class="{ 'input__text--error': $v.form.contact.email.$error }" v-model="$v.form.contact.email.$model"  />
                    <span class="detailedstep__error" v-if="$v.form.contact.email.$error && !$v.form.contact.email.required">Contact email is required</span>
                    <span class="detailedstep__error" v-else-if="$v.form.contact.email.$error && !$v.form.contact.email.email">Please enter a valid email</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>
                <div class="detailedstep__input">
                    <input type="text" name="contact_phone" placeholder="Telephone*" class="input__text" :class="{ 'input__text--error': $v.form.contact.phone.$error }" v-model="$v.form.contact.phone.$model" />
                    <span class="detailedstep__error" v-if="$v.form.contact.phone.$error && !$v.form.contact.phone.required">Contact phone number is required</span>
                    <span class="detailedstep__error" v-else-if="$v.form.contact.phone.$error && !$v.form.contact.phone.phoneValid">Please enter a valid phone number</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>
                <div class="detailedstep__input">
                    <input type="text" name="contact_occupation" placeholder="Position in company*" class="input__text" :class="{ 'input__text--error': $v.form.contact.position.$error }" v-model="$v.form.contact.position.$model" />
                    <span class="detailedstep__error" v-if="$v.form.contact.position.$error && !$v.form.contact.position.required">Contact position in company is required</span>
                    <span class="detailedstep__valid" v-else>Field ok</span>
                </div>
                <div class="detailedstep__form">
                    <a href="#" class="button__next text-white" @click.prevent="saveData()">Next Step</a>
                </div>    
            </div>  
         </div>
         <single-testimonial></single-testimonial>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapGetters, mapActions} from 'vuex';
import SingleTestimonial from '../testimonials/SingleTestimonial';
import Sidebar from '../sidebar/Sidebar';
import { required, email, numeric, maxLength } from 'vuelidate/lib/validators';
const isPhone = (value) => /^[0-9$\-() +]+$/.test(value)

export default {
    components:{
        'multiselect':Multiselect,
        'sidebar':Sidebar,
        'single-testimonial':SingleTestimonial
    },
    data(){
        return {
            counties_list: [],
            cities_list: [],
            form:{
                business:{
                    name:'',
                    country: '',
                    county:'',
                    town:'',
                    address:'',
                    website:'',
                    email: '',
                    phone: ''
                },
                contact:{
                    name:'',
                    surname:'',
                    email:'',
                    phone:'',
                    position: '',
                }
            }
        }
    },
    validations:{
        form:{
            business:{
                name:{
                    required
                },
                country: {
                  required
                },
                county:{
                    required
                },
                town:{
                    required
                },
                address:{
                    required,
                    maxLength: 150
                },
                email: {
                    required,
                    email
                },
                phone: {
                    required,
                    phoneValid: isPhone
                },
            },
            contact:{
                name:{
                    required
                },
                surname:{
                    required
                },
                email:{
                    required,
                    email
                },
                phone:{
                    required,
                    phoneValid: isPhone
                },
                position: {
                    required
                }
            }
        }
    },
    methods:{
        ...mapActions([
            'saveBasicInformation'
        ]),
        saveData(){
            this.$v.$touch();
            if(this.$v.$invalid){
                return;
            }else{
                 this.saveBasicInformation(this.form);
            }

        },
        fetchCounties() {
            if(this.form.business.country) {
                axios.get('/api/countries/' + this.form.business.country.id + '/counties')
                    .then(response=>{
                    this.counties_list = response.data.counties;
                    this.form.business.county = this.counties_list[0];
                    this.fetchCities();
            })
            }
        },

        fetchCities() {
            axios.get('/api/counties/' + this.form.business.county.id + '/cities')
                .then(response=> {
                    this.cities_list = response.data.cities;
                    this.form.business.town = this.cities_list[0];

         })
        },

    },
    mounted() {
        console.log(this.getCountriesList);
        this.form.business.country = this.getCountriesList[0];
        this.fetchCounties();
    },

    computed:{
        ...mapGetters([
            'getBusinessForm',
            'getContactForm',
            'getCountriesList'
        ])
    }
}
</script>
